module.exports = __webpack_public_path__ + "static/media/Aldsworth Attic Bookcases & cupboards (2).438acc39.jpg";